/**
 * Purely vanilla tagged template literal with the `html` symbol,
 * which will trigger many syntax highlighters to treat the content
 * as HTML instead of a plain string. Does nothing special with the
 * content.
 *
 * Only use for interpolating known-safe HTML content (e.g. in base layouts).
 *
 * @returns
 */
export function html(strings: TemplateStringsArray, ...values: unknown[]) {
  return strings.reduce((result, string, i) => {
    const value = values[i - 1];
    return result + (value !== undefined ? value : '') + string;
  }, '');
}
